import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

// Redux Actions
import { nextStep, previousStep } from './../redux/step'
import { setTimeInfo } from './../redux/form'

// Custom
import CustomCard from './../components/CustomCard'
import TimeSlots from './TimeSlots'

// Spacing
const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 3, xl: 4 }

function Form25(props) {

    // Props
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const form = useSelector(state => state.form)
    const timeSlots = useSelector(state => state.timeSlots)
    const loading = useSelector(state => state.loading)
    const theme = useTheme();


    // Styles
    const styles = {
        formRoot: {
            width: '100%'
        },
        checkboxChecked: {
            color: theme.palette.success.main,
        },
    }


    // Media query screen size
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));



    // Calculate spacing 
    const spacingForm = useMemo(() => {

        const spacings = { xs: 2, sm: 2, md: 3, lg: 3, xl: 4 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // On mount
    useEffect(() => {

        return () => {
            // Clean up
        }
    }, [])


    // Forms TODO: get initial values
    const [timeSlot, setTimeSlot] = useState(form.timeSlot);
    const [slot, setSlot] = useState(form.slot);

    // Form error states
    const [timeSlotError, setTimeSlotError] = useState(false);
    const [slotError, setSlotError] = useState(false);

    const [nextButton, setNextButtonColor] = useState('inherit');

    // Previous step
    function handleBackButton() {
        dispatch(previousStep())
    }

    // Next step
    function handleNextStep() {

        if (loading) { return }

        // Form validation
        let error = false;
        if (!timeSlot) {
            error = true
            setTimeSlotError(true)
        }
        if (!slot) {
            error = true
            setSlotError(true)
        }

        // Don't proceed if there is an error  TODO:
        if (!error) {
            // Save info to redux
            dispatch(setTimeInfo({
                slot,
                timeSlot,
            }))

            // Next step
            dispatch(nextStep())
        }

    }

    function onSlotChange(timeSlot) {
        if (timeSlot) {
            setNextButtonColor('secondary')
        } else {
            setNextButtonColor('inherit')
        }
    }

    function getCardContent() {
        return (
            <form className={styles.formRoot} noValidate autoComplete="off">
                <Grid container direction="column" wrap='nowrap' spacing={spacingForm}>
                    {/* Form */}
                    {
                        form.dealer &&
                        <Grid item xs={'auto'} style={{ 'flexGrow': 1 }}>
                            <TimeSlots
                                timeSlots={timeSlots}
                                timeSlot={timeSlot}
                                onTimeSlotChange={(timeSlot) => { setTimeSlot(timeSlot); }}
                                slot={slot}
                                onSlotChange={(slot) => { setSlot(slot); onSlotChange(slot); }}
                                error={timeSlotError || slotError}
                                onErrorChange={(error) => {
                                    setTimeSlotError(error)
                                    setSlotError(error)
                                }}
                            />
                        </Grid>
                    }
                </Grid>
            </form>
        )
    }

    function getCardActions() {
        return (
            <Box display='flex' justifyContent='space-between'>
                <Button
                    variant="contained"
                    sx={styles.button}
                    onClick={handleBackButton}
                    style={{ width: xsDown ? '40%' : '170px', minHeight: '42px', boxShadow: 'none' }}
                >
                    {t('backButton')}
                </Button>
                <Button variant="contained" color={nextButton} style={{ width: xsDown ? '40%' : '170px', minHeight: '42px', boxShadow: 'none', marginLeft: '5px' }} onClick={handleNextStep}>
                    {t('nextButton')}
                </Button>
            </Box>
        )
    }

    return (
        <CustomCard
            padding={spacingRoot}
            content={getCardContent()}
            action={getCardActions()}
        />
    )

}

// Connect redux and translation
export default Form25